import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import ChevronLeft from '@/assets/icon/ChevronLeft';
import Burger from '@/assets/icon/Olybet/menu.svg';
import BingolyLogo from '@/assets/images/Olybet/bingoly.svg';

import { useSettings } from '@/hooks/useSettings.hook';

import { RoutesEnum } from '@/enums/routes.enum';

import { tKeys } from '@/i18n/resourses';

import * as S from './Header.styles';

type IHeaderProps = {
  handleClick: () => void;
};

const Header: React.FC<IHeaderProps> = ({ handleClick }) => {
  const { pagesWithBackButton } = useSettings();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <S.Wrapper id='header'>
      <S.WrapperInner>
        {!pagesWithBackButton ? (
          <S.BurgerButton onClick={handleClick}>
            <img alt='' height={34} src={Burger} width={34} />
          </S.BurgerButton>
        ) : (
          <S.BurgerButton onClick={() => navigate(RoutesEnum.play)}>
            <ChevronLeft />
          </S.BurgerButton>
        )}
        {pathname === RoutesEnum.help ? (
          <div
            style={{
              color: '#FFFFFF',
              fontSize: '20px',
              fontWeight: '600',
              textAlign: 'center',
              textTransform: 'capitalize',
            }}
          >
            {t(tKeys.howToPlay)}
          </div>
        ) : (
          <Link to={RoutesEnum.play}>
            <S.ImageLogo alt='logo' src={BingolyLogo} />
          </Link>
        )}

        {/*<S.InfoButton onClick={() => navigate(RoutesEnum.help)}>*/}
        {/*  <img alt='' height={34} src={CircleInfo} width={34} />*/}
        {/*</S.InfoButton>*/}
      </S.WrapperInner>
    </S.Wrapper>
  );
};

export default Header;
